import React, { ChangeEvent } from 'react';
import { FormField } from './FormField';

interface TextInputProps {
    id: string;
    label: string;
    value: string | null | undefined;
    onChange: (value: string) => void;
    onBlur?: () => void;
    required?: boolean;
    disabled?: boolean;
    maxLength?: number;
    placeholder?: string;
    tooltip?: string;
    error?: string;
    className?: string;
    type?: 'text' | 'password' | 'email';
    autoFocus?: boolean;
    dataLpIgnore?: boolean;
    autoComplete?: string;
    name?: string;
    ariaAutoComplete?: string;
    inputMode?: string;
    list?: string;
}

export const TextInput: React.FC<TextInputProps> = ({
    id,
    label,
    value,
    onChange,
    onBlur,
    required = false,
    disabled = false,
    maxLength,
    placeholder,
    tooltip,
    error,
    className = '',
    type = 'text',
    autoFocus = false,
    dataLpIgnore = false,
    autoComplete,
    name,
    ariaAutoComplete,
    inputMode,
    list
}) => {
    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        onChange(e.target.value);
    };

    return (
        <FormField
            label={label}
            id={id}
            required={required}
            tooltip={tooltip}
            error={error}
        >
            <input
                type={type}
                id={id}
                className={`form-control ${className}`}
                required={required}
                maxLength={maxLength}
                placeholder={placeholder}
                onBlur={onBlur}
                onChange={handleChange}
                value={value || ''}
                disabled={disabled}
                autoFocus={autoFocus}
                data-lpignore={dataLpIgnore}
                autoComplete={autoComplete}
                name={name}
                aria-autocomplete={ariaAutoComplete as any}
                inputMode={inputMode as any}
                list={list}
            />
        </FormField>
    );
};
